import { useCallback } from 'react'
import { useError } from 'react-use'

// TODO: Separate errors common to both generic and specific tenants
//  from errors related only to specific tenants
export enum RenderErrorType {
  OsIsNotAvailable = 'OS is not available',
  OsIsNotReady = 'OS is not ready',
  DataIsNotAvailable = 'Data is not available',
  ForbiddenPage = 'Forbidden page',
  ForbiddenOSAccess = 'Forbidden OS access',
  NotFound = 'Not found',
  CriticalError = 'Critical error',
  AppDisabled = 'App is disabled',
  AppUnsupportedAppearance = 'App appearance is not supported',
  ForbiddenHubAccess = 'Forbidden hub access',
}

export class RenderError extends Error {
  cause!: RenderErrorType

  constructor(type: RenderErrorType) {
    super(`RenderError: ${type}`, { cause: type })
  }
}

export const useDispatchRenderError = () => {
  const dispatchError = useError()

  return useCallback(
    (type: RenderErrorType) => {
      dispatchError(new RenderError(type))
    },
    [dispatchError],
  )
}
